import { render, staticRenderFns } from "./LectureLessonInfoNotification.vue?vue&type=template&id=f5b91ae0&"
import script from "./LectureLessonInfoNotification.vue?vue&type=script&lang=js&"
export * from "./LectureLessonInfoNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports